import React, { useEffect, useRef, useState } from 'react';
import './App.css';

// Custom hook for scroll animations
function useScrollAnimation() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const el = ref.current;
    if (el) {
      observer.observe(el);
    }

    return () => {
      if (el) {
        observer.unobserve(el);
      }
    };
  }, []);

  return [ref, isVisible];
}

// Toast Notification Component
function Toast({ message, type, isVisible, onClose }) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className={`toast toast-${type} ${isVisible ? 'toast-show' : ''}`}>
      <div className="toast-content">
        <div className="toast-icon">
          {type === 'success' ? '✓' : '⚠'}
        </div>
        <div className="toast-message">{message}</div>
        <button className="toast-close" onClick={onClose}>×</button>
      </div>
    </div>
  );
}

const VIDEO_BG = "/one.gif";
const INTRO_VIDEO_WEB = "/intro-web-2560x1440.mp4";
const INTRO_VIDEO_MOBILE = "/intro-mobile-1080x1800.mp4";
const MASCOT_IMG = "https://firebasestorage.googleapis.com/v0/b/fun-website-af042.firebasestorage.app/o/Fun%20Mascot%202.png?alt=media&token=00c41584-3923-4139-939b-c360d11e11e4";
const LOGO_IMG = "/funLogotype.svg";
const WELCOME_GIF = "https://firebasestorage.googleapis.com/v0/b/fun-website-af042.firebasestorage.app/o/Fun%20Site.gif?alt=media&token=0efd72d5-bdd8-4f78-9cca-a2a632a9201e";
// Demo version - Cart functionality removed

// Demo version - ProductCard with Order Now button
function ProductCard({ product, coverImage, hoverImage }) {
  const [hovered, setHovered] = React.useState(false);
  
  const handleOrderNow = () => {
    window.open('https://t.me/funthc', '_blank');
  };

  const handleCardClick = () => {
    window.open('https://t.me/funthc', '_blank');
  };

  return (
    <div className="product-card-ui" style={{textAlign: 'center', cursor: 'pointer'}}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleCardClick}
    >
      <div className="product-img-wrap">
        <img
          src={hoverImage}
          alt={product.name}
          className="product-img product-img-cover"
          style={{
            opacity: 1,
            transform: hovered ? 'scale(1.06)' : 'scale(1)',
            zIndex: 1
          }}
        />
      </div>
      <div className="product-details-section">
        <div className="product-details-left">
          <div className="product-name">{product.name}</div>
          <div className="product-category">{product.category || 'Product Category'}</div>
        </div>
      </div>
      <div style={{marginTop: '16px', width: '100%', padding: '0'}}>
        <button 
          onClick={(e) => {
            e.stopPropagation();
            handleOrderNow();
          }}
          style={{
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            padding: '12px 24px',
            fontSize: '0.9rem',
            fontWeight: '600',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            width: '100%',
            maxWidth: 'none',
            boxSizing: 'border-box'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#333';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#000';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          Order Now
        </button>
      </div>
    </div>
  );
}

// Demo version - ProductSection removed (Trending, Bestsellers, Kits sections removed)

// Demo version - TrendingProducts removed

// Demo version - FeaturedProducts with 2 products and Order Now button
function FeaturedProducts() {
  const [ref, isVisible] = useScrollAnimation();
  const featuredProducts = [
    {
      id: 1,
      name: 'Rosin Dabgo',
      category: 'Fresh Pressed Rosin',
      coverImage: 'https://firebasestorage.googleapis.com/v0/b/fun-website-af042.firebasestorage.app/o/Frame%207.jpg?alt=media&token=101b3605-83db-447f-a08a-e1d5edcbda2d',
      hoverImage: '/dabgoFront1.jpg'
    },
    {
      id: 2,
      name: 'Rosin Disposable',
      category: 'Rosin Disposables',
      coverImage: 'https://firebasestorage.googleapis.com/v0/b/fun-website-af042.firebasestorage.app/o/Frame%206.jpg?alt=media&token=19da8686-9085-455e-8b41-c2045d8af047',
      hoverImage: '/rosinFront1.jpg'
    }
  ];

  return (
    <section 
      ref={ref}
      id="featured" 
      className={`featured-products-section-ui scroll-animate ${isVisible ? 'animate-in' : ''}`}
      style={{padding: '64px 0', backgroundColor: '#fff'}}
    >
      <div className={`scroll-animate-content ${isVisible ? 'animate-in' : ''}`} style={{textAlign: 'center', marginBottom: '48px'}}>
        <h2 style={{fontSize: '2.5rem', fontWeight: '700', margin: '0 0 16px 0', color: '#222', fontFamily: 'Benzin, Inter, Arial, sans-serif', textTransform: 'uppercase', letterSpacing: '0.05em'}}>Life Should Be Fün</h2>
      </div>
      <div className={`scroll-animate-grid ${isVisible ? 'animate-in' : ''}`} style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '32px', width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '0 24px', boxSizing: 'border-box'}}>
        {featuredProducts.map((product, index) => (
          <div 
            key={product.id} 
            className={`scroll-animate-item ${isVisible ? 'animate-in' : ''}`}
            style={{
              textAlign: 'center',
              animationDelay: `${index * 0.2}s`
            }}
          >
            <ProductCard 
              product={product} 
              coverImage={product.coverImage}
              hoverImage={product.hoverImage}
            />
      </div>
        ))}
      </div>
    </section>
  );
}

// Poster Section Component
function PosterSection() {
  const [ref, isVisible] = useScrollAnimation();
  
  return (
    <section 
      ref={ref}
      id="poster" 
      className={`poster-section scroll-animate ${isVisible ? 'animate-in' : ''}`}
      style={{
        backgroundColor: '#fff',
        padding: '80px 48px',
        width: '100%',
        maxWidth: '100vw',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div 
        className={`scroll-animate-content ${isVisible ? 'animate-in' : ''}`}
        style={{
          maxWidth: '1400px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <img
          src="/funPoster_Tex.jpg"
          alt="Fun Poster"
          style={{
            width: '100%',
            maxWidth: '1200px',
            height: 'auto',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>
    </section>
  );
}

function AboutSection({ introVideoSrc }) {
  const [ref, isVisible] = useScrollAnimation();
  
  return (
    <section 
      ref={ref}
      id="about" 
      className={`framer-jdmuct scroll-animate ${isVisible ? 'animate-in' : ''}`} 
      data-framer-name="About Section"
      style={{width: '100vw', overflow: 'hidden'}}
    >
      <div className="framer-1lgcdem" data-framer-name="Container" style={{width: '100vw', margin: 0, padding: 0, maxWidth: 'none'}}>
        <div className="framer-66ha2q" data-framer-name="About Content Wrapper" style={{width: '100vw', height: '100vh', margin: 0}}>
          <video
            src={introVideoSrc}
            autoPlay
            loop
            muted
            playsInline
            style={{width: '100vw', height: '100vh', objectFit: 'cover', display: 'block'}}
            aria-label="About"
          />
        </div>
      </div>
    </section>
  );
}

// Demo version - Cart component removed

// Demo version - InstagramTilesSection (JOIN OUR COMMUNITY) removed

// Demo version - SearchOverlay removed

// Demo version - FavoritesOverlay removed

function App() {
  const [loading, setLoading] = useState(true);
  const [showIntro, setShowIntro] = useState(false);
  const [showHero, setShowHero] = useState(false);
  const [showAgePopup, setShowAgePopup] = useState(false);
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [mascotLoaded, setMascotLoaded] = useState(false);
  const [toast, setToast] = useState({ isVisible: false, message: '', type: 'success' });
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.matchMedia('(max-width: 767px)').matches : false
  );
  const videoRef = useRef(null);
  const introVideoSrc = isMobile ? INTRO_VIDEO_MOBILE : INTRO_VIDEO_WEB;

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const handleChange = (event) => setIsMobile(event.matches);
    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // Preload mascot image
  useEffect(() => {
    const img = new window.Image();
    img.src = MASCOT_IMG;
    img.onload = () => setMascotLoaded(true);
  }, []);

  // Simulate loading (wait for video to be ready)
  useEffect(() => {
    const handleLoaded = () => {
      setLoading(false);
      setShowIntro(true);
    };
    // Preload video
    const video = document.createElement('video');
    video.src = introVideoSrc;
    video.oncanplaythrough = handleLoaded;
    video.load();
    return () => {
      video.oncanplaythrough = null;
    };
  }, [introVideoSrc]);

  // When intro video ends, show hero
  const handleVideoEnd = () => {
    setShowIntro(false);
    setTimeout(() => setShowHero(true), 200); // Small delay for smooth fade
  };

  // Show age popup 6s after hero appears, but only after mascot image is loaded
  useEffect(() => {
    let timer;
    if (showHero && mascotLoaded) {
      timer = setTimeout(() => setShowAgePopup(true), 6000);
    }
    return () => clearTimeout(timer);
  }, [showHero, mascotLoaded]);

  // Show welcome popup 10s after age confirmation
  useEffect(() => {
    let welcomeTimer;
    if (ageConfirmed) {
      welcomeTimer = setTimeout(() => setShowWelcomePopup(true), 10000);
    }
    return () => clearTimeout(welcomeTimer);
  }, [ageConfirmed]);

  // Age popup handlers
  const handleAgeYes = () => {
    setShowAgePopup(false);
    setAgeConfirmed(true);
  };
  const handleAgeNo = () => {
    window.location.href = 'https://www.google.com';
  };
  const handleAgeClose = () => setShowAgePopup(false);

  // Toast functions
  const showToast = (message, type = 'success') => {
    setToast({ isVisible: true, message, type });
  };

  const hideToast = () => {
    setToast({ isVisible: false, message: '', type: 'success' });
  };

  // Form submission to Google Sheets
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      showToast('Please enter a valid email address', 'error');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      showToast('Please enter a valid email address', 'error');
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Google Sheets API endpoint
      const GOOGLE_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbzftM7DqJBqU6DM4I40660mJyXp4Gtuk7kIebFLoISt2bn0Nkl51qCwCe83Fg2VBC45/exec';
      
      const formData = new FormData();
      formData.append('email', email.trim().toLowerCase());
      formData.append('timestamp', new Date().toISOString());
      formData.append('source', 'welcome_popup');
      formData.append('userAgent', navigator.userAgent);
      
      await fetch(GOOGLE_SHEETS_URL, {
        method: 'POST',
        mode: 'no-cors', // This allows cross-origin requests
        body: formData
      });
      
      showToast('Thanks! You\'ll receive your discount code soon.', 'success');
      setEmail('');
      setShowWelcomePopup(false);
    } catch (error) {
      console.error('Google Sheets submission error:', error);
      
      // Fallback to localStorage if Google Sheets fails
      try {
        const emails = JSON.parse(localStorage.getItem('pendingEmails') || '[]');
        const emailData = {
          email: email.trim().toLowerCase(),
          timestamp: new Date().toISOString(),
          source: 'welcome_popup',
          userAgent: navigator.userAgent
        };
        
        // Check if email already exists
        const exists = emails.some(item => item.email === emailData.email);
        if (!exists) {
          emails.push(emailData);
          localStorage.setItem('pendingEmails', JSON.stringify(emails));
        }
        
        showToast('Thanks! Your email has been saved. We\'ll contact you soon!', 'success');
        setEmail('');
        setShowWelcomePopup(false);
      } catch (localError) {
        console.error('Local storage error:', localError);
        showToast('Something went wrong. Please try again.', 'error');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="hero-container">
      {/* Loading Animation */}
      {loading && (
        <div className="loader-overlay">
          <div className="loader" />
        </div>
      )}
      {/* Intro Video */}
      {showIntro && (
        <div className="intro-video-overlay" onClick={handleVideoEnd} style={{ cursor: 'pointer' }}>
          <video
            ref={videoRef}
            src={introVideoSrc}
            className="intro-video"
            autoPlay
            muted
            playsInline
            onEnded={handleVideoEnd}
            style={{ width: '100vw', height: '100vh', objectFit: 'cover' }}
          />
          <div style={{
            position: 'absolute',
            bottom: '80px',
            left: '50%',
            transform: 'translateX(-50%)',
            color: '#fff',
            fontSize: '16px',
            fontWeight: '500',
            letterSpacing: '0.5px',
            textAlign: 'center',
            opacity: '0.8',
            pointerEvents: 'none',
            zIndex: 10
          }}>
            Click to skip
          </div>
        </div>
      )}
      {/* Hero Section */}
      <div className={`hero-main-content${showHero ? ' hero-fade-in' : ''}${showIntro || loading ? ' hero-hidden' : ''}`}>
        {/* Background GIF */}
        <img src={VIDEO_BG} alt="Background Animation" className="hero-bg" />
        {/* Black overlay for better text visibility */}
        <div className="hero-bg-overlay" />
        {/* Overlay for content */}
        <div className="hero-overlay">
          {/* Navigation - Demo version simplified */}
          <nav className="hero-nav">
            <div className="nav-left">
              <img src={LOGO_IMG} alt="FunTHC Logo" className="nav-logo-img" />
            </div>
            <div className="nav-right">
                    <a href="#featured">Products</a>
                    {/* <a href="#gallery">Gallery</a> */}
                    <a href="#about">About</a>
                    <a href="https://t.me/funthc" target="_blank" rel="noopener noreferrer">Contact</a>
            </div>
          </nav>
          {/* Hero Content - no tagline or shop button per client */}
          <div className="hero-content">
            <div className="hero-text" />
          </div>
        </div>
      </div>
      {showHero && !showIntro && !loading && (
        <>
          <FeaturedProducts />
          {/* Gallery hidden temporarily */}
          {/* <Gallery /> */}
          <PosterSection />
          <AboutSection introVideoSrc={introVideoSrc} />
          {/* Demo version - InstagramTilesSection removed */}
        </>
      )}
      
      {/* Demo version - Cart Component removed */}
      
      {/* Age Confirmation Popup */}
      {showAgePopup && (
        <div className="age-popup-overlay darken-bg">
          <div className="age-popup-modal no-radius">
            <button className="age-popup-close" onClick={handleAgeClose} aria-label="Close">
              <div className="close-icon"></div>
            </button>
            <img className="age-popup-mascot" src={MASCOT_IMG} alt="Mascot" />
            <div className="age-popup-subtitle">Age Verification</div>
            <div className="age-popup-title">Are you 21 or older?</div>
            <div className="age-popup-desc">By clicking "Yes" you confirm you are of legal age to purchase and consume cannabis products in your jurisdiction. We don't ask, we just deliver.</div>
            <div className="age-popup-actions">
              <button className="age-popup-btn no-radius" onClick={handleAgeNo}>No</button>
              <button className="age-popup-btn no-radius" onClick={handleAgeYes}>Yes</button>
            </div>
          </div>
        </div>
      )}
      {/* Welcome Offer Popup */}
      {showWelcomePopup && (
        <div className="welcome-popup-overlay" style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          {/* Black overlay for dimming background */}
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.25)',
            zIndex: 1
          }} />
          <div className="welcome-popup-bg" style={{display: 'none'}}>
            <img src={WELCOME_GIF} alt="Welcome Background" />
          </div>
          <button className="welcome-popup-close" onClick={() => setShowWelcomePopup(false)} aria-label="Close" style={{zIndex: 3, position: 'absolute', top: 24, right: 24}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" focusable="false" style={{ width: '28px', height: '28px', fill: 'rgb(0, 0, 0)' }}>
              <g>
                <path d="M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"></path>
              </g>
            </svg>
          </button>
          <div className="welcome-popup-modal" style={{position: 'relative', zIndex: 3}}>
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/fun-website-af042.firebasestorage.app/o/Fun%20Site%20Jace%203%20(1)%20(1).gif?alt=media&token=088001ec-3a96-49e2-8824-e2d0cfcd35f4" 
              alt="Welcome Mascot" 
              style={{
                width: '240px',
                objectFit: 'contain',
                display: 'block',
                margin: '0 auto 10px auto'
              }}
            />
            <div className="welcome-popup-content" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="welcome-popup-text" style={{textAlign: 'center'}}>
                <p className="welcome-popup-subtitle">Welcome to Fun THC</p>
                <p className="welcome-popup-title">Get 15% off your first order.</p>
              </div>
              <div className="welcome-popup-form" style={{width: '100%'}}>
                <form 
                  method="POST" 
                  style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '6px' }}
                  onSubmit={handleEmailSubmit}
                >
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="name@email.com" 
                    className="welcome-popup-input"
                    autoComplete="off" 
                    autoCapitalize="off" 
                    autoCorrect="off" 
                    spellCheck="false"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isSubmitting}
                  />
                  <input 
                    type="submit" 
                    value={isSubmitting ? "Submitting..." : "Signup"} 
                    className="welcome-popup-submit"
                    disabled={isSubmitting}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Demo version - Search Overlay removed */}
      {/* Demo version - Favorites Overlay removed */}
      
      {/* Toast Notification */}
      <Toast 
        message={toast.message}
        type={toast.type}
        isVisible={toast.isVisible}
        onClose={hideToast}
      />
      
      {/* Footer Section - Demo version simplified */}
      <footer id="contact" style={{backgroundColor: '#fff', width: '100%', opacity: 1, marginTop: 48}}>
        <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'flex-start', padding: '48px 24px 24px 24px', maxWidth: '1200px', margin: '0 auto'}}>
          {/* Left: Logo and tagline */}
          <div style={{minWidth: 220, flex: 1}}>
            <img src="/funLogotype.svg" alt="FunTHC Logo" style={{width: 120, height: 'auto', marginBottom: 8}} />
            <div style={{display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap'}}>
              <a href="https://www.instagram.com/funthc.co" target="_blank" rel="noopener noreferrer" style={{opacity: 0.8, transition: 'opacity 0.3s'}} onMouseEnter={(e) => e.target.style.opacity = 1} onMouseLeave={(e) => e.target.style.opacity = 0.8}>
                <img src="https://framerusercontent.com/images/nmoaO4wWQ4p4IiW6OEbm3bRN80.svg" alt="Instagram" width={24} height={24} />
              </a>
              <a href="https://www.x.com/fun_thc" target="_blank" rel="noopener noreferrer" style={{opacity: 0.8, transition: 'opacity 0.3s'}} onMouseEnter={(e) => e.target.style.opacity = 1} onMouseLeave={(e) => e.target.style.opacity = 0.8}>
                <img src="https://framerusercontent.com/images/a92vLJnjXtWQu6oUSuPWZNVpE.svg" alt="X" width={24} height={24} />
              </a>
              <a href="https://www.tiktok.com/@funthc.co" target="_blank" rel="noopener noreferrer" style={{opacity: 0.8, transition: 'opacity 0.3s'}} onMouseEnter={(e) => e.target.style.opacity = 1} onMouseLeave={(e) => e.target.style.opacity = 0.8}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
              <a href="https://discord.com/invite/funthc" target="_blank" rel="noopener noreferrer" style={{opacity: 0.8, transition: 'opacity 0.3s'}} onMouseEnter={(e) => e.target.style.opacity = 1} onMouseLeave={(e) => e.target.style.opacity = 0.8}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
                </svg>
              </a>
              <a href="https://t.me/funthc" target="_blank" rel="noopener noreferrer" style={{opacity: 0.8, transition: 'opacity 0.3s'}} onMouseEnter={(e) => e.target.style.opacity = 1} onMouseLeave={(e) => e.target.style.opacity = 0.8}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12a12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472c-.18 1.898-.962 6.502-1.36 8.627c-.168.9-.499 1.201-.82 1.23c-.696.065-1.225-.46-1.9-.902c-1.056-.693-1.653-1.124-2.678-1.8c-1.185-.78-.417-1.21.258-1.91c.177-.184 3.247-2.977 3.307-3.23c.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345c-.48.33-.913.49-1.302.48c-.428-.008-1.252-.241-1.865-.44c-.752-.245-1.349-.374-1.297-.789c.027-.216.325-.437.893-.663c3.498-1.524 5.83-2.529 6.998-3.014c3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
              </a>
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: 8, opacity: 0.7, fontSize: 16}}>
              <img src="data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%221.34em%22%20height%3D%221em%22%20viewBox%3D%220%200%20640%20480%22%3E%3Cpath%20fill%3D%22%23bd3d44%22%20d%3D%22M0%200h640v480H0%22%2F%3E%3Cpath%20stroke%3D%22%23fff%22%20stroke-width%3D%2237%22%20d%3D%22M0%2055.3h640M0%20129h640M0%20203h640M0%20277h640M0%20351h640M0%20425h640%22%2F%3E%3Cpath%20fill%3D%22%23192f5d%22%20d%3D%22M0%200h364.8v258.5H0%22%2F%3E%3Cmarker%20id%3D%22flagUs4x30%22%20markerHeight%3D%2230%22%20markerWidth%3D%2230%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22m14%200l9%2027L0%2010h28L5%2027z%22%2F%3E%3C%2Fmarker%3E%3Cpath%20fill%3D%22none%22%20marker-mid%3D%22url(%23flagUs4x30)%22%20d%3D%22m0%200l16%2011h61h61h61h61h60L47%2037h61h61h61h61h60L47%2089h61h61h60h61L16%20115h61h61h61h61h60L47%20141h61h61h60h61L16%20166h61h61h61h61h60L47%20192h61h61h60h61L16%20218h61h61h61h61h60z%22%2F%3E%3C%2Fsvg%3E" alt="Country flag" width={24} height={18} />
              US
            </div>
            <div style={{opacity: 0.4, fontSize: 16, marginTop: 8}}>&copy;2025 FunTHC</div>
          </div>
          {/* Center: Navigation - Demo version simplified */}
          <div style={{display: 'flex', flex: 3, justifyContent: 'center', gap: 128, flexWrap: 'wrap', minWidth: 600}}>
            <div>
              <div style={{opacity: 0.4, fontWeight: 500, marginBottom: 8}}>Shop</div>
              <div><a href="/">Home</a></div>
              <div><a href="https://www.t.me/funthc" target="_blank" rel="noopener noreferrer">Buy now</a></div>
              {/* <div><a href="#gallery">Gallery</a></div> */}
              <div><a href="#about">About</a></div>
              <div><a href="https://t.me/funthc" target="_blank" rel="noopener noreferrer">Contact</a></div>
            </div>
            <div>
              <div style={{opacity: 0.4, fontWeight: 500, marginBottom: 8}}>Products</div>
              <div><a href="#featured">All</a></div>
              <div><a href="#featured">Fresh Pressed Rosin</a></div>
              <div><a href="#featured">Rosin Disposables</a></div>
            </div>
          </div>
          {/* Right: Made by, payment icons */}
          <div style={{minWidth: 220, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 16}}>
            <div style={{display: 'flex', gap: 8, marginTop: 8}}>
              <img src="https://framerusercontent.com/images/OksZYUjbLIh7cgKYAKuiweuiOjw.svg" alt="Visa" width={32} height={12} />
              <img src="https://framerusercontent.com/images/rFUkelsWHapnYN0IuPXKg8KWQM.svg" alt="Mastercard" width={32} height={20} />
              <img src="https://framerusercontent.com/images/BjiKhXBZ4CzI1fOvMCfDPpgUE.svg" alt="Stripe" width={32} height={14} />
              <img src="https://framerusercontent.com/images/xHd1ycr88aMS4obTktsiFlmZbA.svg" alt="PayPal" width={32} height={12} />
              <img src="https://framerusercontent.com/images/m009yH1MzvuyG97edfJ9pCWvo.svg" alt="Google Pay" width={32} height={13} />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;